(() => {
  const sectionSelector = '[data-loyalty-benefits]';
  const initialized = 'loyaltyBenefitsInitialized';

  const initSection = (section) => {
    if (!section || section.dataset[initialized] === 'true') return;

    const track = section.querySelector('[data-loyalty-benefits-track]');
    const slides = track ? Array.from(track.children) : [];
    const dots = Array.from(section.querySelectorAll('[data-loyalty-benefits-dots] span'));
    if (!track || slides.length < 2 || dots.length !== slides.length) return;

    section.dataset[initialized] = 'true';
    let frame = 0;
    let activeIndex = -1;

    const updateDots = () => {
      frame = 0;
      const firstOffset = slides[0].offsetLeft;
      const nextIndex = track.scrollWidth > track.clientWidth + 1
        ? slides.reduce((closest, slide, index) => (
          Math.abs((slide.offsetLeft - firstOffset) - track.scrollLeft)
            < Math.abs((slides[closest].offsetLeft - firstOffset) - track.scrollLeft)
            ? index
            : closest
        ), 0)
        : 0;

      if (nextIndex === activeIndex) return;
      activeIndex = nextIndex;
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };

    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(updateDots);
    };

    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleUpdate) : null;
    resizeObserver?.observe(track);
    if (!resizeObserver) window.addEventListener('resize', scheduleUpdate, { passive: true });

    section.loyaltyBenefitsCleanup = () => {
      if (frame) window.cancelAnimationFrame(frame);
      track.removeEventListener('scroll', scheduleUpdate);
      resizeObserver?.disconnect();
      if (!resizeObserver) window.removeEventListener('resize', scheduleUpdate);
      delete section.dataset[initialized];
    };

    updateDots();
  };

  const init = (root = document) => {
    if (root.matches?.(sectionSelector)) initSection(root);
    root.querySelectorAll?.(sectionSelector).forEach(initSection);
  };

  if (window.loyaltyBenefitsCarousel) {
    window.loyaltyBenefitsCarousel.init(document);
    return;
  }

  window.loyaltyBenefitsCarousel = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(sectionSelector)
      ? event.target
      : event.target.querySelector?.(sectionSelector);
    section?.loyaltyBenefitsCleanup?.();
  });
})();
